import React from 'react';
import TechReferenceGuide from './components/TechReferenceGuide';  // Removed .tsx extension

function App() {
  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <TechReferenceGuide />
      </div>
    </div>
  );
}

export default App;
